import { RedusxAppState } from "../reducers/rootReducer";

export const userSelector = (state: RedusxAppState) => state.user
export const hostPropertyList = (state: RedusxAppState) => state.hostProperty.hostPropertyList